import { gql, TypedDocumentNode } from '@common/hooks';
import {
  LoadBalancingProjectedUnassignedShiftCountQueryCgResponse,
  LoadBalancingProjectedUnassignedShiftCountQueryVariables,
} from '@common/graphql';

// Server-side count of the assigned shifts a deactivating save would sweep for the
// given inactive window, across every in-review schedule in the organization — the
// number behind the "Save and Unassign" confirmation (WORK-8875). Computed by the same
// finder the sweep uses, so the warning can never disagree with the removal.
export const PROJECTED_UNASSIGNED_SHIFT_COUNT_QUERY: TypedDocumentNode<
  LoadBalancingProjectedUnassignedShiftCountQueryCgResponse,
  LoadBalancingProjectedUnassignedShiftCountQueryVariables
> = gql`
  query LoadBalancingProjectedUnassignedShiftCount(
    $id: ID!
    $effectiveStartDate: ISO8601Date!
    $effectiveEndDate: ISO8601Date
  ) {
    loadBalancingWorker(id: $id) {
      id
      projectedUnassignedShiftCount(
        effectiveStartDate: $effectiveStartDate
        effectiveEndDate: $effectiveEndDate
      )
    }
  }
`;
